import React from "react";
import { GiftIcon } from "lucide-react";
interface BonusItem {
  title: string;
  description: string;
  src: string;
  alt: string;
}
const bonuses: BonusItem[] = [{
  title: "Bono 1 · Hoja de ejercicios domiciliarios",
  description: "Plan editable para tus pacientes entre sesiones.",
  src: "https://cdn.magicpatterns.com/uploads/qMCjCbg34oDhh9jQB7PZB1/Bono_1.png",
  alt: "Bono 1: hoja de ejercicios para casa"
}, {
  title: "Bono 2 · Ficha de satisfacción post-alta",
  description: "Recoge feedback al cerrar el tratamiento.",
  src: "https://cdn.magicpatterns.com/uploads/1K1g62SzQXdNAsUfSgUkwF/Bono_2_.png",
  alt: "Bono 2: ficha de satisfacción post-alta"
}, {
  title: "Bono 3 · Presupuesto de tratamiento",
  description: "Sesiones, costes y condiciones en un solo formato.",
  src: "https://cdn.magicpatterns.com/uploads/kcCk5tTg8DrWs2H34K6si8/Bono_3.png",
  alt: "Bono 3: plantilla de presupuesto de tratamiento"
}, {
  title: "Bono 4 · Contraindicaciones por técnica",
  description: "Consulta rápida para trabajar con seguridad.",
  src: "https://cdn.magicpatterns.com/uploads/3KzfFhR7cV6K6p5gsssBAy/Bono_4.png",
  alt: "Bono 4: ficha de contraindicaciones por técnica"
}, {
  title: "Bono 5 · Glosario de abreviaturas clínicas",
  description: "Referencia práctica para tu documentación clínica.",
  src: "https://cdn.magicpatterns.com/uploads/cUM4aTRp8KgJZso21SQcAq/Bono_5r.png",
  alt: "Bono 5: glosario de abreviaturas clínicas"
}, {
  title: "Bono 6 · Ficha de contacto de emergencia",
  description: "Datos esenciales del paciente en una sola ficha.",
  src: "https://cdn.magicpatterns.com/uploads/rsMARQigCnmUt8wBp6Yobq/Bono_6.png",
  alt: "Bono 6: ficha de contacto de emergencia"
}, {
  title: "Bono 7 · Checklist RGPD",
  description: "Revisa los puntos clave de protección de datos.",
  src: "https://cdn.magicpatterns.com/uploads/uk9BsZm8UdfRbDTZPUXZ8M/Bono_7_.png",
  alt: "Bono 7: checklist RGPD para historia clínica"
}, {
  title: "Bono 8 · Valoración postural",
  description: "Esquema corporal para documentar hallazgos.",
  src: "https://cdn.magicpatterns.com/uploads/3ThQH1uGpGgV9iKi9sKNrt/Bono_8.png",
  alt: "Bono 8: ficha de valoración postural"
}];
export function Bonuses() {
  return <section className="px-4 pt-12" data-id="element-26" data-mp="3qi5y0yrbz1ag">
      <div className="mx-auto max-w-md" data-id="element-27" data-mp="2tseygl46mnxs">
        <p className="text-center text-[15px] leading-relaxed text-slate-600" data-id="element-28" data-mp="2ttq4krl3o7s2">
          Espera, sabemos que quizás faltan cosas por cubrir. Por eso agregamos los
          siguientes <strong className="text-slate-800" data-id="element-29" data-mp="32slas3o59hvd">bonos sin cargo</strong>:
        </p>

        <div className="mt-4 flex justify-center rounded-full bg-amber-100 py-2 text-sm font-extrabold text-amber-700" data-id="element-30" data-mp="37jjtf9wlus1s">
          🎁 GRATIS solo por el día de hoy
        </div>

        <div className="mt-5 space-y-3" data-id="element-31" data-mp="2a2cz8uo45vpr">
          {bonuses.map(bonus => <article key={bonus.title} className="overflow-hidden rounded-2xl border border-amber-200 bg-white shadow-sm" data-id="element-32" data-mp="2f1pnnjumvaug">
              <img src={bonus.src} alt={bonus.alt} className="aspect-[16/6] w-full object-cover object-top" loading="lazy" data-id="element-33" data-mp="22kna134dws7r" />
              <div className="p-3" data-id="element-34" data-mp="1tj6xopu0eg0w">
                <p className="text-[12px] font-extrabold leading-snug text-slate-800" data-id="element-35" data-mp="1tjyrbv41q3oj">
                  {bonus.title}
                </p>
                <p className="mt-1 text-[11px] leading-snug text-slate-500" data-id="element-36" data-mp="1juoz8f97cl0f">
                  {bonus.description}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-5 flex items-center justify-center gap-1.5 rounded-2xl border border-teal-200 bg-teal-50 px-2 py-3 text-[10px] font-bold tracking-tight text-teal-800 whitespace-nowrap" data-id="element-37" data-mp="19wrfa3ydladm">
          <GiftIcon className="h-4 w-4 shrink-0 text-teal-600" data-id="element-38" data-mp="10vt5f519a8n4" />
          Todos estos bonos son gratis por el día de hoy.
        </div>
      </div>
    </section>;
}